// Dependencies
import {
  TARIFAS_VENTA_REQUEST,
  TARIFAS_VENTA_OK,
  TARIFAS_VENTA_ERROR,
} from "./types";
import { get } from "../../../../api/apiInstance";

const fetchTarifasVenta = () => async (dispatch) => {
  try {
    const response = await get("/tarifas");
    const data = response["data"];
    dispatch({
      type: TARIFAS_VENTA_OK,
      payload: { data: data["data"], qty: data["rowsAffected"] },
    });
    return Promise.resolve();
  } catch (error) {
    dispatch({ type: TARIFAS_VENTA_ERROR, payload: error });
    return Promise.reject(error);
  }
};

export const getTarifasVenta = () => (dispatch) => {
  dispatch({ type: TARIFAS_VENTA_REQUEST });
  dispatch(fetchTarifasVenta());
};
